export default "__VITE_ASSET__WzhuIzVb__"